import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DevisState } from './devis.state';

export const selectDevis = createFeatureSelector<DevisState>('devis');

export const selectDevisState = createSelector(selectDevis, (state: DevisState) => state.Devis);
